import { NgModule } from 'ng-metadata/core';
import { TimestampPipe } from './timestamp.pipe';
import { TruncatePipe } from './truncate.pipe';
import { TruncateHtmlPipe } from './truncate-html.pipe';
import { TruncateNumberPipe } from './truncate-number.pipe';
import { UsNumberSystemPipe } from './us-number-system.pipe';
import { LocaleService } from './locale.service';
import { TruncateDirective } from './truncate.directive';
import { TruncateNumberComponent } from './truncate-number.component';

/**
 * @ngdoc module
 * @name mw.components.dataFormatting
 * @description
 *
 * Data Formatting module
 */
@NgModule({
    providers: [
        LocaleService
    ],
    declarations: [
        TimestampPipe,
        TruncatePipe,
        TruncateHtmlPipe,
        TruncateNumberPipe,
        UsNumberSystemPipe,
        TruncateDirective,
        TruncateNumberComponent
    ]
})
export class DataFormattingModule {
    constructor() {}
}



// WEBPACK FOOTER //
// ./src/lib/components/data-formatting/data-formatting.module.ts